module.exports = __webpack_public_path__ + "img/ring_g_l_0_1@2x.74235ed8.png";